import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis'
})
export class EllipsisPipe implements PipeTransform {

  transform(target: string, maxLength: number = 300) {
    if (!target) return target;

    if (target.length >= maxLength) {
      return `${target.slice(0, maxLength)}...`;
    }
    return target;
  }

}
